import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-template-actualizar-datos',
    templateUrl: './template-actualizar-datos.component.html',
    styleUrls: ['./template-actualizar-datos.component.scss'],
    standalone: false
})
export class TemplateActualizarDatosComponent implements OnInit {
  user: any = null;
  subTitle = '';
  actividades: any[] = [];
  constructor(
    private readonly _userService: UserService
  ) {
    this.user = this._userService.getUser();
  }

  ngOnInit(): void {
    if (this.user?.tipoPersona === 'natural') {
      this.subTitle = 'persona natural';
    } else {
      this.subTitle = 'persona jurídica';
    }
  }
}
